export const VARIANTS = {
  DEFAULT: "default",
  DARK_BG: "darkBg",
};
